import { render, staticRenderFns } from "./NestedDetailsv2.vue?vue&type=template&id=76f63dfd&"
import script from "./NestedDetailsv2.vue?vue&type=script&lang=js&"
export * from "./NestedDetailsv2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports